import React, { useContext, useEffect, useState } from 'react'
import * as staticConstants from '../../../translations/en/en';
import toast from 'react-hot-toast';
import { InformationAlert } from '../../common';
import textUtils from '../../../utils/TextUtils';
import * as ApiConst from '../../../api/ApiConst';
import { GlobalContext } from '../../../reducer/context';
import { callPostApiWithoutAuth } from '../../../api/ApiCaller';
import { FILL_REGISTER_DETAILS, LOGIN } from '../../../reducer/actions/userActions';
import { NO_ERROR } from '../../../api/constants';
import { registerDetails } from '../../../reducer/initialStates/initialStates';
import { requestNotificationPermission } from '../../../firebase/firebaseUtilities';
import { Link } from 'react-router-dom';

const LoginPage = () => {
    const { authState, dispatchAuth } = useContext(GlobalContext);
    const { registerDetails: user } = authState;
    const [errors, setErrors] = useState({ mobileNumber: '', otp: '' });
    const [isOtpGenerated, setIsOtpGenerated] = useState(false);

    const handleUserChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobileNumber') {
            if (isNaN(value)) return false;
            if (value.length > 10) return false;
            // Reset OTP generated state when mobile number changes
            if (isOtpGenerated) {
                setIsOtpGenerated(false);
                dispatchAuth({ type: FILL_REGISTER_DETAILS, payload: { otp: '' } });
            }
        }
        if (name === 'otp') {
            if (isNaN(value)) return false;
            if (value.length > 4) return false;
        }
        dispatchAuth({ type: FILL_REGISTER_DETAILS, payload: { [name]: value } });
        setErrors({ ...errors, [name]: '' });
    };

    const handleGenerateOtp = () => {
        if (!user.mobileNumber || user.mobileNumber.trim() === '') {
            setErrors({ mobileNumber: staticConstants.PLEASE_ENTER_VALID_MOBILE_NUMBER });
            return;
        }
        if (!textUtils.isMobile(user.mobileNumber)) {
            setErrors({ mobileNumber: staticConstants.PLEASE_ENTER_VALID_MOBILE_NUMBER });
            return;
        }
        setErrors({});
        const generateOtpUrl = ApiConst.Generate_Otp;
        const toastId = toast.loading(staticConstants.PLEASE_WAIT);
        callPostApiWithoutAuth(generateOtpUrl, user, (response) => {
            toast.dismiss(toastId);
            if (response.errorCode === NO_ERROR) {
                setIsOtpGenerated(true);
                InformationAlert({ message: response.message });
            } else {
                setIsOtpGenerated(false);
                setErrors({ mobileNumber: response.message });
            }
        });
    };

    // will constantly check the OTP if all fields all filled then it'll call api for OTP verification
    useEffect(() => {
        if (user.otp.length === 4) {
            handleVerifyOtp();
        }
    }, [user.otp]);

    const resetStates = () => {
        setErrors({ mobileNumber: '', otp: '' });
        setIsOtpGenerated(false);
        dispatchAuth({ type: FILL_REGISTER_DETAILS, payload: { ...registerDetails } });
    };

    const handleVerifyOtp = () => {
        const rObj = { mobileNumber: user.mobileNumber, oneTimePassword: user.otp };
        const toastId = toast.loading(staticConstants.VERIFYING_OTP);
        callPostApiWithoutAuth(ApiConst.Verify_Otp, rObj, (response) => {
            toast.dismiss(toastId);
            if (response.errorCode === NO_ERROR) {
                requestNotificationPermission()
                dispatchAuth({ type: LOGIN, payload: response.responsePacket });
                resetStates();
                // if (!response.responsePacket.fullName) {
                // } else {
                //     // InformationAlert({ message: response.message });
                // }
            } else {
                setErrors({ otp: `*${response.message}` });
            }
        });
    };

    return (
        <>
            <div className='special-header'>
                <Link to='/' className='brand-wrap mb-0'>
                    <img alt='logo' className='img-fluid mobile-logo' src='../img/mobile_logo.png' width="612" height="152" style={{ width: "auto" }} />
                </Link>
            </div>
            <div className='special-ocassion my-2'>
                <div className='bg-white'>
                    <div class="login-header">
                        <div class="login-back-box">
                            <img src="../img/login-bg.png" />
                            <div class="login-front-box">
                                <img src="../img/logo-login.png" />
                            </div>
                        </div>
                    </div>
                    <div className='login-form p-3'>
                        <div className='number-div text-center'>
                            <h4 className='text-black font-weight-900 mb-3 font-size-24'>{staticConstants.WELCOME_TO_PYRAMID}</h4>
                            <h6 className='text-dark mb-3'>{staticConstants.PLEASE_ENTER_YOUR_MOBILE_NUMBER}</h6>
                            <div>
                                {/* <label htmlFor="">Mobile Number</label> */}
                                <div className='mt-2 position-relative '>
                                    <div className='form-group login-form-group  d-flex align-items-center'>
                                        <span className='border-end country-code px-2 font-size-16'>{user.isdCode}</span>
                                        <input
                                            type='tel'
                                            className='form-control'
                                            id='ec-mobile-number'
                                            aria-describedby='emailHelp'
                                            placeholder='Enter 10 digit mobile number'
                                            name='mobileNumber'
                                            value={user.mobileNumber}
                                            onChange={handleUserChange}
                                        />
                                    </div>
                                    <button
                                        onClick={handleGenerateOtp}
                                        className="bg-yellow text-black get-otp-btn"
                                        disabled={!user.mobileNumber || user.mobileNumber.length !== 10}
                                    >
                                        {"GET OTP"}
                                    </button>
                                </div>
                            </div>
                            {errors.mobileNumber && <div className='text-left mt-2'><span style={{ color: '#cf000f' }}>{errors.mobileNumber}</span></div>}
                            <div className='mt-2 position-relative pb-4'>
                                {/* <label htmlFor="">OTP</label> */}
                                <div className='form-group login-form-group mb-0 d-flex align-items-center'>
                                    <input
                                        type='text'
                                        className='form-control'
                                        id='ec-otp'
                                        aria-describedby='otpHelp'
                                        placeholder='Enter OTP'
                                        name='otp'
                                        value={user.otp}
                                        onChange={handleUserChange}
                                        disabled={!isOtpGenerated}
                                    />
                                </div>
                                {errors.otp && <div className='text-left position-absolute bottom-0'><span style={{ color: '#cf000f' }}>{errors.otp}</span></div>}
                            </div>
                            <div className='form-group'>
                                <button
                                    onClick={handleVerifyOtp}
                                    className='btn bg-yellow text-black font-weight-900 font-size-18 d-block py-3 login-btn w-100'
                                    disabled={!isOtpGenerated || !user.otp || user.otp.length !== 4}
                                >
                                    {staticConstants.LOGIN}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginPage